export type BreadcrumbsProps = {
  breadcrumbs: Breadcrumb[];
};

export type Breadcrumb = {
  name: string;
  path: string;
};

export function Breadcrumbs(props: BreadcrumbsProps): JSX.Element {
  const { breadcrumbs } = props;

  return (
    <div className="mb-4 flex flex-row items-center gap-3 py-4 lg:gap-5">
      <div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="13"
          height="14"
          viewBox="0 0 13 14"
          fill="none"
        >
          <path
            d="M10.9625 13.7501H8.41251C8.24345 13.7501 8.08131 13.6789 7.96173 13.5524C7.8422 13.4257 7.77501 13.2541 7.77501 13.0751V9.02506H5.22501V13.0751C5.22501 13.2541 5.15783 13.4257 5.0383 13.5524C4.91871 13.6789 4.75656 13.7501 4.58751 13.7501H2.03751C1.53045 13.7494 1.04436 13.5359 0.685815 13.1563C0.327271 12.7766 0.125623 12.262 0.125014 11.7251V6.28006C0.123741 5.86867 0.211895 5.4625 0.382564 5.09294C0.553286 4.72339 0.802025 4.40036 1.10948 4.14887L5.32548 0.676671C5.66111 0.399996 6.07432 0.249756 6.49966 0.249756C6.92498 0.249756 7.3382 0.399996 7.67384 0.676671L11.8898 4.14902C12.1974 4.40039 12.4462 4.72336 12.617 5.09291C12.7879 5.46241 12.8761 5.86858 12.875 6.28003V11.725C12.8744 12.2619 12.6727 12.7766 12.3142 13.1562C11.9556 13.5359 11.4695 13.7494 10.9625 13.75L10.9625 13.7501ZM9.05001 12.4001H10.9625C11.1315 12.3999 11.2936 12.3287 11.4131 12.2021C11.5326 12.0756 11.5999 11.904 11.6 11.7251V6.28006C11.6013 5.86316 11.4194 5.46935 11.1079 5.21447L6.89104 1.74227C6.77909 1.65005 6.64136 1.59995 6.49952 1.59995C6.35768 1.59995 6.2199 1.65004 6.10799 1.74227L1.89299 5.21447C1.58109 5.46917 1.39887 5.86298 1.39997 6.28006V11.7251C1.40014 11.904 1.46737 12.0756 1.5869 12.2021C1.70638 12.3287 1.86846 12.3999 2.03747 12.4001H3.94997V9.02506C3.95036 8.66717 4.08483 8.32405 4.32384 8.07092C4.56291 7.81786 4.88697 7.67548 5.22497 7.67506H7.77497C8.11297 7.67547 8.43704 7.81785 8.6761 8.07092C8.9151 8.32405 9.04957 8.66717 9.04997 9.02506L9.05001 12.4001Z"
            fill="#333333"
          />
        </svg>
      </div>

      {breadcrumbs && breadcrumbs.length > 0
        ? breadcrumbs.map((breadcrumb, index) => {
            return (
              <div
                key={index}
                className="flex flex-row items-center gap-3 last:font-semibold last:italic lg:gap-5"
              >
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="5"
                    height="9"
                    viewBox="0 0 5 9"
                    fill="none"
                  >
                    <path
                      d="M5 4.28239L4.59055 3.85364L0.891111 -1.79605e-07L-3.74779e-08 0.857395L3.29006 4.28228L-3.36891e-07 7.70717L0.891111 8.56457L4.59055 4.71093L5 4.28239Z"
                      fill="#CCCCCC"
                    />
                  </svg>
                </div>

                <a
                  href={breadcrumb.path}
                  className="text-body-12 truncate text-onyx hover:text-teal"
                >
                  {breadcrumb.name}
                </a>
              </div>
            );
          })
        : null}
    </div>
  );
}
